import type { Medical, MedicalType } from "@qendo/medical/types";
import type { OptionData } from "@qendo/types";

export enum AllergyLevel {
    known = "known",
    suspected = "suspected",
    sensitivity = "sensitivity",
}

export const AllergyLevelMap: Record<AllergyLevel, string> = {
    [AllergyLevel.known]: "Known allergy",
    [AllergyLevel.suspected]: "Suspected allergy",
    [AllergyLevel.sensitivity]: "Sensitivity",
};

export type AllergyOptionData = OptionData;

export interface AllergyData extends Medical<MedicalType.allergy> {
    flag: boolean;
    level: AllergyLevel;
}
